import React from 'react'
import fp from 'lodash/fp'
import PropTypes from 'prop-types'
import { BrowserRouter as Router } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { ContentLoader, XHRErrorCatcher } from 'shared/components'
import { TableControllerHost } from 'shared/components/table'

import { ServicesContext } from './services/context'
import { StoreContext } from './store/context'
import ApplicationRoutes from './routes'

const ApplicationComponent = ({ data, loading }) => {
  const appStore = fp.first(data)
  const services = fp.last(data)

  return (
    <ContentLoader loading={loading} fixed>
      <ServicesContext.Provider value={services}>
        <StoreContext.Provider value={appStore}>
          <TableControllerHost>
            <XHRErrorCatcher>
              <Router basename={BASEHREF}>
                <div id="toastbox">
                  <ToastContainer />
                </div>
                <ApplicationRoutes />
              </Router>
            </XHRErrorCatcher>
          </TableControllerHost>
        </StoreContext.Provider>
      </ServicesContext.Provider>
    </ContentLoader>
  )
}

ApplicationComponent.propTypes = {
  loading: PropTypes.bool.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape()),
}

export default ApplicationComponent
